/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} P1portal_Group_TalkInputs */



/**
* | output |
* | --- |
* | "Talk" |
*
* @param {P1portal_Group_TalkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const p1portal_group_talk = /** @type {((inputs?: P1portal_Group_TalkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<P1portal_Group_TalkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Talk")
});